import { getPersonSchema } from "@/services/api";
import type { InferType } from "yup";

export const getActivitiesTabSchema = () =>
  getPersonSchema().pick([
    "professionalActivities",
    "careers",
    "educations",
    "competences",
    "hobbies",
  ]);

export type ActivitiesTabFormValues = InferType<ReturnType<typeof getActivitiesTabSchema>>;
